module.exports = __webpack_public_path__ + "img/productPrice.ff2edc06.png";